module.exports = __webpack_public_path__ + "img/title11.f8a7d251.png";